import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface DatabaseViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class DatabaseViewPage extends Component<DatabaseViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.database(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}